// Report-wise rights (Users & Roles → Reports). Each report head (Sale Reports,
// Purchase Reports …) keeps its tick exactly as before; inside a head, single
// reports can now be switched off for a role.
//
// Stored on the role as permissions.reportItems = { <report id>: false } — only
// the reports switched OFF are written. So:
//   - every existing role keeps all its reports (nothing to migrate);
//   - a report added later is ON wherever its head is ON;
//   - the head tick stays the master switch (head off = none of its reports),
//     and the server rules that read the head tick are untouched.
// A per-user value (companyUser.permissions.reportItems) wins over the role,
// the same way user values work for the other rights.
// Firebase cost: nothing — roles are already loaded at login.

import { ALL_MODULES, ROUTE_TO_MODULE } from '../config/moduleRegistry';

export const REPORT_ITEMS_KEY = 'reportItems';

/** The reports that belong to one head (e.g. 'saleReports'), in menu order. */
export const reportsOfHead = (headKey) =>
  ALL_MODULES.filter((m) => m.permission && m.permission.category === 'reports' && m.permission.key === headKey);

/** Is this single report allowed by the role / user (the head is checked separately)? */
export const reportItemAllowed = (reportId, rolePermissions, userOverrides) => {
  const u = userOverrides && userOverrides[REPORT_ITEMS_KEY] ? userOverrides[REPORT_ITEMS_KEY][reportId] : undefined;
  if (u === true || u === false) return u;
  const r = rolePermissions && rolePermissions[REPORT_ITEMS_KEY] ? rolePermissions[REPORT_ITEMS_KEY][reportId] : undefined;
  return r !== false;
};

/** The report behind a page address, or null when the page is not a report. */
export const reportForRoute = (routePath) => {
  const m = ROUTE_TO_MODULE[routePath];
  return m && m.permission && m.permission.category === 'reports' ? m : null;
};
